import { render, staticRenderFns } from "./TeamInfo.vue?vue&type=template&id=60f17444&"
import script from "./TeamInfo.vue?vue&type=script&lang=js&"
export * from "./TeamInfo.vue?vue&type=script&lang=js&"
import style0 from "./TeamInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports